import { ContentItem, GeoRow, InvoiceAge, ProductRow, QuotePipeline, RecentActivity } from "../types";

export const C = {
  or:     "#BF3D0C",
  or2:    "#E8593C",
  green:  "#4ec9a6",
  blue:   "#8ab4f8",
  purple: "#c678f5",
  amber:  "#f5a623",
  red:    "#e05252",
  teal:   "#38bdf8",
  pink:   "#f472b6",
  dim:    "rgba(255,255,255,0.06)",
  grid:   "rgba(255,255,255,0.05)",
  text:   'var("--text")',
  text2:  "#b4b2a9",
  text3:  "#6a6a65",
};

export const GEO_DATA: GeoRow[] = [
  { country:"United Kingdom", flag:"🇬🇧", quotes:4,  revenue:18240, pct:22 },
  { country:"India",          flag:"🇮🇳", quotes:3,  revenue:15360, pct:18 },
  { country:"UAE",            flag:"🇦🇪", quotes:2,  revenue:14260, pct:17 },
  { country:"Norway",         flag:"🇳🇴", quotes:2,  revenue:10920, pct:13 },
  { country:"USA",            flag:"🇺🇸", quotes:2,  revenue:9600,  pct:11 },
  { country:"Brazil",         flag:"🇧🇷", quotes:2,  revenue:7220,  pct:9  },
  { country:"Japan",          flag:"🇯🇵", quotes:1,  revenue:8900,  pct:10 },
];

export const PRODUCT_ROWS: ProductRow[] = [
  { name:"GNSS Receiver GNX-Pro",       sku:"GNX-PRO",  category:"Surveying",   views:1842, quotes:6, revenue:51200, trend:[3200,4100,3800,5200,5600,6400,7100,6800,7400,8100,7200,8300], status:"published" },
  { name:"Total Station TS-900",         sku:"TS-900",   category:"Instruments", views:1340, quotes:4, revenue:37600, trend:[2100,2800,3100,2900,3400,3800,4100,3700,4200,4600,4100,4800], status:"published" },
  { name:"Drone Survey Bundle",          sku:"DSB-001",  category:"Surveying",   views:1105, quotes:3, revenue:26700, trend:[1800,2200,1900,2400,2600,2900,3100,2800,3200,3400,3100,3600], status:"published" },
  { name:"RTK Base Station Kit",         sku:"RTK-BASE", category:"Surveying",   views: 987, quotes:3, revenue:19200, trend:[1200,1600,1400,1800,1900,2100,2300,2000,2400,2600,2300,2700], status:"published" },
  { name:"Laser Distance Meter LDM-400", sku:"LDM-400",  category:"Instruments", views: 854, quotes:3, revenue:12600, trend:[800,1100,900,1200,1300,1400,1500,1300,1600,1700,1500,1800],  status:"published" },
  { name:"Aurel Field Jacket — Pro",     sku:"AFJ-PRO",  category:"Apparel",     views: 732, quotes:2, revenue:7220,  trend:[400,500,460,580,620,680,720,660,740,800,720,840],              status:"published" },
  { name:"Carbon Fibre Tripod CF-7",     sku:"CF7-TRP",  category:"Accessories", views: 621, quotes:2, revenue:10920, trend:[600,800,700,900,960,1020,1080,1000,1120,1200,1080,1240],       status:"published" },
  { name:"Safety Helmet SH-200",         sku:"SH-200",   category:"Safety",      views: 498, quotes:1, revenue:4025,  trend:[200,260,220,300,320,340,360,330,370,400,360,420],              status:"published" },
];

export const QUOTE_PIPELINE: QuotePipeline[] = [
  { status:"New",          count:3,  value:0,     color:C.blue   },
  { status:"Reviewing",    count:4,  value:0,     color:C.amber  },
  { status:"Quoted",       count:2,  value:17000, color:C.purple },
  { status:"Sample Sent",  count:3,  value:0,     color:C.teal   },
  { status:"Approved",     count:2,  value:6700,  color:C.green  },
  { status:"Rejected",     count:1,  value:0,     color:C.red    },
];

export const INVOICE_AGING: InvoiceAge[] = [
  { bucket:"Current",   count:5,  amount:64445, color:C.green  },
  { bucket:"1–30 days", count:3,  amount:28380, color:C.amber  },
  { bucket:"31–60 days",count:2,  amount:11060, color:C.or     },
  { bucket:"60+ days",  count:2,  amount:13625, color:C.red    },
];

export const CONTENT_ITEMS: ContentItem[] = [
  { type:"Product",       name:"GNSS Receiver GNX-Pro",        status:"published", updated:"Today",     views:1842 },
  { type:"Certification", name:"ISO 9001:2015",                 status:"published", updated:"Yesterday", views:312  },
  { type:"Product",       name:"Aurel Field Jacket — Pro",      status:"published", updated:"2 days ago",views:732  },
  { type:"Page",          name:"Home Page",                     status:"published", updated:"3 days ago",views:5421 },
  { type:"Certification", name:"CE Marking Certificate",        status:"published", updated:"4 days ago",views:198  },
  { type:"Product",       name:"Safety Helmet SH-200",          status:"draft",     updated:"5 days ago",views:498  },
  { type:"Page",          name:"About Us",                      status:"published", updated:"1 week ago",views:2140 },
];

export const RECENT_ACTIVITY: RecentActivity[] = [
  { icon:"💰", action:"Invoice INV-2025-0002 paid — $15,360",    time:"2h ago",   type:"finance"  },
  { icon:"📋", action:"New quote request from GeoTech Arabia",   time:"3h ago",   type:"quote"    },
  { icon:"✅", action:"Certification ISO 14001 published",       time:"5h ago",   type:"content"  },
  { icon:"📦", action:"Product 'GNSS Receiver' updated",         time:"Yesterday",type:"content"  },
  { icon:"⚠️", action:"Invoice INV-2025-0005 is overdue",        time:"Yesterday",type:"alert"    },
  { icon:"📁", action:"12 files uploaded to /products",          time:"2 days ago",type:"files"   },
  { icon:"💳", action:"Quote QR-2025-1003 approved — $4,200",    time:"2 days ago",type:"quote"    },
  { icon:"🔑", action:"Admin password changed",                  time:"3 days ago",type:"security"},
];